import i18next from "i18next";
import HttpBackend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";
import moment from "moment";

import { languageCodeToMomentLocaleFile } from "../../../../shared/dateConstants";

const setMomentLocale = async (locale: string): Promise<void> => {
  const momentLocaleDir = languageCodeToMomentLocaleFile[locale];
  if (momentLocaleDir) {
    await import(`moment/locale/${momentLocaleDir}`);
  }

  moment.locale(locale);
};

export const initializeLocale = async (locale: string): Promise<void> => {
  await i18next
    .use(HttpBackend)
    .use(initReactI18next)
    .init({
      debug: process.env.NODE_ENV === "development",

      ns: ["EHRConnectorConfig"],
      defaultNS: "EHRConnectorConfig",
      fallbackNS: "EHRConnectorConfig",
      nsSeparator: false,

      lng: locale,
      fallbackLng: "en-US",
      partialBundledLanguages: false,

      saveMissing: true,
      saveMissingTo: "current",
      updateMissing: true,

      keySeparator: false,
      interpolation: {
        escapeValue: false, // Not needed for react
      },

      react: {
        wait: true,
      },

      backend: {
        loadPath: "assets/locales/{{lng}}/{{ns}}.json",
        addPath: "assets/locales/add/{{lng}}/{{ns}}",
      },
    });

  await setMomentLocale(locale);
};

export const changeLocale = async (locale: string): Promise<void> => {
  // change the language
  await i18next.changeLanguage(locale);
  await setMomentLocale(locale);
};

export const getLocale = (): string => {
  return i18next.language;
};
